import React, { useState, useEffect, useContext } from 'react'
import { useForm, FormProvider } from 'react-hook-form'
import Form from 'react-bootstrap/Form'
import Tab from 'react-bootstrap/Tab'
import Row from 'react-bootstrap/Row'
import { StepContext } from '../StepContext'
import { TabsBimestre } from './UtilsFieldArray'
import CargandoDatosLoader from '../components/CargandoDatosLoader'
import DatosPago from './DatosPago'
import { TotalPagoBimestre, TotalPagoAnual } from './Totales'

import { LEGAJO_UNICO } from 'utils/legajo'
import { guardarPagos } from '../utils/requests'

const itemNuevo = {
  pagComprobante: '',
  pagBocaRecaudadora: '',
  importe: '',
  pagFecReg: '',
  tshBimestre: '',
  pagLegajo: '',
  tshTipoCarga: 'A',
  tshSecuencia: ''
}
const defaultValues = [1, 2, 3, 4, 5, 6].reduce((acc, n) => {
  let item = {}
  item[`bimestre${n}`] = {
    name: `bimestre${n}`,
    bimestre: n,
    pagos: []
  }
  return { ...acc, ...item }
}, {})

const Pagos = () => {
  const { setPuedeAvanzar, setCallback } = useContext(StepContext)
  const [datosCuit, setDatosCuit] = useState([])
  const [loading, setLoading] = useState(true)
  const [pagos, setPagos] = useState([])
  const methods = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues
  })

  const { trigger, formState, getValues } = methods

  const guardarPagosDeSistema = () => {
    const datos = JSON.stringify({
      pagos: Object.values(getValues({ nest: true }))
        .flatMap((x) => Object.values(x))
        .flatMap((x) => Object.values(x))
        .flatMap((x) => Object.values(x))
    })
    trigger()
    if (!formState.isValid) {
      return false
    }
    return guardarPagos(datos).then(({ status, content }) => {
      if (status === 200) {
        return true
      } else {
        trigger()
        console.log(content)
      }
    })
  }
  useEffect(() => {
    setCallback(guardarPagosDeSistema)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setCallback])

  useEffect(() => {
    let posible = true
    setLoading(true)
    fetch('/ddjj/api/datos-pagos')
      .then((res) => res.json())
      .then((res) => {
        if (posible) {
          setDatosCuit(res.data)
          setPagos(res.pagos)
          setLoading(false)
        }
      })
    return () => {
      posible = false
    }
  }, [setCallback])

  useEffect(() => {
    setPuedeAvanzar(true)
  }, [setPuedeAvanzar])

  const dataCuit = datosCuit?.filter(function (
    DatoActual,
    PosicionActual,
    arry
  ) {
    return (
      !PosicionActual || DatoActual.legajo !== arry[PosicionActual - 1].legajo
    )
  })
  const legajos = dataCuit?.map((data) => data.legajo)
  return (
    <CargandoDatosLoader cargando={loading}>
      <FormProvider {...methods}>
        <Form onSubmit={methods.handleSubmit((data) => console.log(data))}>
          <Tab.Container defaultActiveKey={1}>
            <TabsBimestre values={Object.values(defaultValues)} />

            <Row className="container-fluid">
              <Tab.Content className="w-100">
                {Object.values(defaultValues).map((state, index) => (
                  <Tab.Pane key={index} eventKey={state.bimestre}>
                    {legajos ? (
                      legajos?.map((nroLegajo, index) => (
                        <div key={index}>
                          <h4 className="text-muted text-uppercase text-center"
			      style={{display: nroLegajo === LEGAJO_UNICO ? 'none' : 'block'}}
			  >
                            {`Legajo ${nroLegajo}`}
                          </h4>
                          <hr className="m-0 mb-4" />
                          <h6 className="text-bold text-uppercase text-left">
                            {`Pagos realizados`}
                          </h6>
                          <DatosPago
                            name={`${state.name}.pagos.legajo${nroLegajo}`}
                            bimestre={`bimestre${state.bimestre}`}
                            arrayName={`legajo${nroLegajo}`}
                            item={itemNuevo}
                            methods={methods}
                            pagosRealizados={pagos}
                            legajo={nroLegajo}
                            bimes={state.bimestre}
                          />
                        </div>
                      ))
                    ) : (
                      <></>
                    )}

                    <TotalPagoBimestre
                      watch={methods.watch}
                      titulo={`Total Bimestre ${state.bimestre}`}
                      bimestre={`bimestre${state.bimestre}`}
                    />
                  </Tab.Pane>
                ))}
              </Tab.Content>
            </Row>
            <TotalPagoAnual watch={methods.watch} />
          </Tab.Container>
        </Form>
      </FormProvider>
    </CargandoDatosLoader>
  )
}

Pagos.propTypes = {}

export default Pagos
